enum GreetingPrefix {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
  GENERIC = 'generic',
}

/**
 * Determines the greeting prefix based on the time of day
 * Uses the local timezone (not UTC) to determine the appropriate greeting
 * @returns Greeting prefix: 'morning', 'afternoon', 'evening', or 'generic'
 */
export function getGreetingPrefix(): GreetingPrefix {
  // getHours() returns the hour in the local timezone (0-23)
  const currentHour = new Date().getHours();

  // 12:00 AM - 12:00 PM (0-11): morning
  // 12:00 PM - 5:00 PM (12-16): afternoon
  // 5:00 PM - 12:00 AM (17-23): evening

  const ranges = [
    { max: 12, prefix: GreetingPrefix.MORNING },
    { max: 17, prefix: GreetingPrefix.AFTERNOON },
    { max: 24, prefix: GreetingPrefix.EVENING },
  ];

  return ranges.find((range) => currentHour < range.max)?.prefix || GreetingPrefix.GENERIC;
}
